// extracted by mini-css-extract-plugin
module.exports = {"downloader":"style_downloader__TkCPA","card":"style_card__3UMa3","body":"style_body__kniMg"};